var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "mku-tree" },
    _vm._l(_vm.dataCopyed, function(node, index) {
      return _c("mku-tree-node", {
        key: index,
        attrs: {
          data: node,
          label: _vm.label,
          children: _vm.children,
          "show-checkbox": _vm.showCheckbox,
          "node-key": _vm.nodeKey,
          "default-expanded-keys": _vm.defaultExpandedKeys,
          "default-checked-keys": _vm.defaultCheckedKeys,
          "default-expand-all": _vm.defaultExpandAll,
          accordion: _vm.accordion,
          "render-content": _vm.renderContent,
          "parent-data": _vm.dataCopyed
        }
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }